const Colors = {
  blueDark: '#024787',
  blueSoft: '#549DDF',
  blueWhite: '#E7F3FF',
  black: '#202020',
  white: '#fff',
  grey: '#DADADA',
  greyDark: '#E7E7E7',
  neutral: '#586479',

  purplePure: '#3633C6',
  purpleDark: '#1D1C6B',
  purpleSoft: '#7A78DB',
  purpleWhite: '#E9E9FF',

  primary: '#004C3B',

  red: '#B4112E',
  redDark: '#9B225F',
  redLight: '#E40E41',
  pink: '#FFB9CE',
  pinkWhite: '#FDF3F6',
  orange: '#E87A46',
  secondaryGreen: '#022E39',

  yellow: '#FDEACD',
  jura: '#FF9B00',
};

export default Colors;
